import { useCallback, useRef } from 'react';

import { iaRa } from 'lib/helpers/utility';

import StatesPickerModal from '../components/StatesPickerModal/StatesPickerModal';

export const useOpenStatesModal = ({
  openModal,
  stateOptions,
  oppositeStateMap,
  updateProviderStates
}) => {
  const statesPickerRef = useRef();

  return useCallback(
    (provider, fieldName) => {
      if (!openModal) return;

      const isInNetwork = fieldName === 'in_network_providers';
      const providerId = provider?.provider_id ?? provider?.value ?? provider?.id;
      const providerName =
        provider?.label ?? provider?.fullName ?? provider?.bill_name ?? 'provider';
      const blockedStateIds = oppositeStateMap[fieldName]?.get?.(providerId);
      const initialStateIds = iaRa(provider?.state_ids);

      const handleSave = (id, nextIds) => updateProviderStates(fieldName, id, nextIds);

      const StatesPickerModalContent = () => (
        <StatesPickerModal
          ref={statesPickerRef}
          providerId={providerId}
          initialStateIds={initialStateIds}
          stateOptions={stateOptions}
          blockedStateIds={blockedStateIds}
          isInNetwork={isInNetwork}
          onSave={handleSave}
        />
      );

      openModal({
        title: `Edit states for ${providerName}`,
        content: StatesPickerModalContent,
        submitText: initialStateIds.length ? 'Save changes' : 'Add states',
        onSubmit: () => statesPickerRef.current?.handleSave?.()
      });
    },
    [openModal, stateOptions, oppositeStateMap, updateProviderStates]
  );
};
